module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-image-2-800x533-cdb9aa333cbdb5b8c2352903fe27f4a9.jpg";